export default __webpack_public_path__ + "934e221a44b1c134963db0e05b46c846.svg";